import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0274',
    ecrans: ['00-2'],
    params: ['id', '?tagcleint_ori', '?tgncleint', '?tgpcleint']
});
